/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DivideGradersAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    [
        'graders',
        /* #__PURE__ */ codec.record(codecString, 
        /* #__PURE__ */ codecOneOf([codecNumber, codecNumber])),
    ],
]);
export class DivideGradersAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DivideGradersAssignmentDataParser.decode(input).map(res => new DivideGradersAssignmentData(res));
    }
    static unsafeDecode(input) {
        return DivideGradersAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DivideGradersAssignmentDataParser.encode(data);
    }
    static schema() {
        return DivideGradersAssignmentDataParser.schema();
    }
}
